import { Admin, Resource } from "react-admin";
import Login from "./view/login";
import WelcomeDashboard from "./view/welcome-dashboard";
import polyglotI18nProvider from "ra-i18n-polyglot";
import portugueseMessages from "./i18n/pt";
import dataProvider from "./provider/data-provider";
import authProvider from "./provider/auth-provider";

// CUSTOMER PASSPORT PHYSICAL
import CustomerPassportPhysicalIcon from "@mui/icons-material/PendingActions";
import CustomerPassportPhysicalList from "./container/customer-passport-physical/list";
import CustomerPassportPhysicalCreate from "./container/customer-passport-physical/create";
import CustomerPassportPhysicalEdit from "./container/customer-passport-physical/edit";
import CustomerPassportPhysicalShow from "./container/customer-passport-physical/show";

import NewLayout from "./ra/override/layout";

import theme from "./theme";

const i18nProvider = polyglotI18nProvider(() => portugueseMessages);

const App = () => (
  <Admin
    theme={theme}
    i18nProvider={i18nProvider}
    dataProvider={dataProvider}
    authProvider={authProvider}
    loginPage={Login}
    dashboard={WelcomeDashboard}
    layout={NewLayout}
    title="Estrada Real Passaporte Admin">
    {
      (permissions) =>
      [
        // CUSTOMER PASSPORT PHYSICAL
        <Resource
          name="customer-passport-physical"
          options={{ label: "Passaporte Físico" }}
          icon={ CustomerPassportPhysicalIcon }
          list={ CustomerPassportPhysicalList }
          create={ CustomerPassportPhysicalCreate }
          show={ CustomerPassportPhysicalShow }
          edit={ (permissions && permissions.is_master === true) ? CustomerPassportPhysicalEdit : null }
        />
      ]
    }
  </Admin>
);

export default App;
